/* ===========================================================
   Everwell motion — IntersectionObservers for fade-up + counters
   =========================================================== */
(function () {
  'use strict';

  if (window.__evMotionInit) return;
  window.__evMotionInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ----- 1. Fade-up / fade entrance observer ----------------------------
  function initFadeIO() {
    var nodes = document.querySelectorAll('[data-ab-animate]:not(.ab-visible)');
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('ab-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var delay = parseInt(e.target.getAttribute('data-ab-delay') || '0', 10);
        if (delay > 0) {
          setTimeout(function () { e.target.classList.add('ab-visible'); }, delay);
        } else {
          e.target.classList.add('ab-visible');
        }
        io.unobserve(e.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  // ----- 2. Counter-up tween --------------------------------------------
  // Usage: <span data-ev-counter data-ev-target="40" data-ev-suffix="+">0</span>
  // Or with a "from": data-ev-from="1900", data-ev-target="1982"
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function tweenCounter(el) {
    var target  = parseFloat(el.getAttribute('data-ev-target'));
    var from    = parseFloat(el.getAttribute('data-ev-from') || '0');
    var suffix  = el.getAttribute('data-ev-suffix') || '';
    var prefix  = el.getAttribute('data-ev-prefix') || '';
    var dur     = parseInt(el.getAttribute('data-ev-duration') || '1400', 10);
    var decimals = parseInt(el.getAttribute('data-ev-decimals') || '0', 10);
    if (isNaN(target)) return;

    if (reduceMotion) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }

    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var v = from + (target - from) * easeOutCubic(p);
      el.textContent = prefix + v.toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounterIO() {
    var nodes = document.querySelectorAll('[data-ev-counter]:not([data-ev-done])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-ev-done', '1'); tweenCounter(n); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.getAttribute('data-ev-done')) return;
        e.target.setAttribute('data-ev-done', '1');
        tweenCounter(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  // ----- 2b. Auto counter — parse number out of element textContent ----
  // Usage: <span data-ev-auto-counter>1982</span>  or  <span data-ev-auto-counter>40+</span>
  // For non-numeric values (e.g. "IEC·BS") we just leave it alone.
  function initAutoCounterIO() {
    var nodes = document.querySelectorAll('[data-ev-auto-counter]:not([data-ev-done])');
    if (!nodes.length) return;

    nodes.forEach(function (n) {
      // Strip any inline HTML to get the plain text (preserves "40+", "1982")
      var raw = (n.textContent || '').trim();
      // Leading-number pattern: optional minus, digits, optional decimal, optional non-digit suffix
      var m = raw.match(/^(-?\d+(?:\.\d+)?)(.*)$/);
      if (!m) { n.setAttribute('data-ev-done', '1'); return; } // non-numeric: skip
      var target = parseFloat(m[1]);
      var suffix = m[2] || '';
      // For year-like values (>= 1900), start the tween from 1900 for a more natural ramp.
      // For small counts, start from 0.
      var from = target >= 1900 ? Math.max(1900, target - 100) : 0;
      // Stash everything onto the element as data-ev-* so tweenCounter can reuse the same code
      n.setAttribute('data-ev-target', String(target));
      n.setAttribute('data-ev-from', String(from));
      n.setAttribute('data-ev-suffix', suffix);
    });

    if (!('IntersectionObserver' in window) || reduceMotion) {
      nodes.forEach(function (n) {
        if (n.getAttribute('data-ev-done')) return;
        n.setAttribute('data-ev-done', '1');
        tweenCounter(n);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        if (e.target.getAttribute('data-ev-done')) return;
        e.target.setAttribute('data-ev-done', '1');
        tweenCounter(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (n) {
      if (n.getAttribute('data-ev-done')) return;
      io.observe(n);
    });
  }

  // ----- 3. Marquee: duplicate the items inside the SAME track ---------
  // We translate the track by -50% so the cloned half slides into place,
  // giving an infinite seamless loop. Cloning the whole track wouldn't
  // animate together — items must be in one continuous strip.
  function initMarquee() {
    var tracks = document.querySelectorAll('.bs-marquee__track:not([data-ev-cloned])');
    tracks.forEach(function (t) {
      t.setAttribute('data-ev-cloned', '1');
      // Freeze the strip until the logos have laid out -- see holdUntilLoaded.
      t.setAttribute('data-ev-hold', '1');
      var originals = Array.prototype.slice.call(t.children);
      originals.forEach(function (child) {
        var c = child.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-ev-marquee-clone', '1');
        // A clone starts life off to the right of the viewport, so a lazy one
        // would not fetch until it scrolled in -- exactly when its arriving
        // width would disturb the loop.
        c.querySelectorAll && Array.prototype.forEach.call(
          c.querySelectorAll('img'),
          function (img) { img.loading = 'eager'; }
        );
        t.appendChild(c);
      });
      holdUntilLoaded(t);
    });
  }

  // The -50% loop offset is a percentage of the track's own width, and the
  // browser re-resolves it whenever that width changes. An image still in
  // flight contributes zero width, so letting the animation run before the
  // logos land makes the strip stutter and mis-wrap. Hold, then release.
  function holdUntilLoaded(track) {
    var release = function () { track.removeAttribute('data-ev-hold'); };
    var pending = Array.prototype.filter.call(
      track.querySelectorAll('img'),
      function (img) { return !img.complete; }
    );
    if (pending.length === 0) { release(); return; }

    var left = pending.length;
    var settle = function () { if (--left <= 0) release(); };
    pending.forEach(function (img) {
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });
    // One logo that never resolves must not leave the strip frozen for good.
    window.setTimeout(release, 3000);
  }

  function boot() {
    initFadeIO();
    initCounterIO();
    initAutoCounterIO();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan after Shopify section reload events (theme editor)
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
